import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import { captureException } from '@playbookux/playbook-web-core';
import Modal from '../../../../core/components/modal-with-input';
import {
  updateMaximumTests,
  UPDATE_PARTICIPANTS_NUMBER,
} from '../graphql';

import { Link } from './styles';
import { schema } from './schema';

const CapResponsesModal = (props) => {
  const {
    label,
    projectId,
    number,
    segmentId,
    linkId,
    type,
    refetch,
  } = props;
  const [newNumber, setNewNumber] = useState(number);
  const [error, setError] = useState();
  const [open, setOpen] = useState(false);

  const [
    changeParticipantsNumber,
    { loading },
  ] = useMutation(UPDATE_PARTICIPANTS_NUMBER, {
    onCompleted: refetch,
  });

  const handleToggleModal = () => {
    setOpen((prev) => !prev);
  };

  const handleValueChange = (value) => {
    setError(null);
    setNewNumber(value);

    schema.validate(value)
      .catch((err) => {
        setError(err.message);
      });
  };

  const handleInputChange = (event, { value }) => {
    handleValueChange(value);
  };

  const handleSubmit = useCallback(async () => {
    if (error) return;
    try {
      if (newNumber >= 0) {
        const newNumberFormated = parseInt(newNumber, 10);
        if (type === 'participants') {
          await changeParticipantsNumber({
            variables: {
              projectId,
              participantsNumber: newNumberFormated,
              rememberCard: false,
              segmentId,
              isAdmin: true,
            },
          });
        } else {
          await updateMaximumTests(projectId, segmentId, linkId, newNumberFormated);
        }
      }
      handleToggleModal();
      await refetch();
    } catch (err) {
      captureException('HANDLE_CHANGE_PARTICIPANTS_NUMBER_FAILED', err);
    }
    handleToggleModal();
  }, [changeParticipantsNumber, error, newNumber, projectId, type]);

  useEffect(() => {
    if (open) {
      handleValueChange(newNumber);
    }
  }, [newNumber, open]);

  const textLink = type === 'participants'
    ? 'Change Number of Participants' : 'Change Maximum Tests';

  return (
    <>
      <Link
        onClick={handleToggleModal}
      >
        {textLink}
      </Link>

      {open && (
        <Modal
          loading={loading}
          label={label}
          buttonText="Update"
          open={open}
          onClose={handleToggleModal}
          onInputChange={handleInputChange}
          value={newNumber}
          error={error}
          submit={handleSubmit}
        />
      )}
    </>
  );
};

CapResponsesModal.propTypes = {
  label: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  projectId: PropTypes.string.isRequired,
  segmentId: PropTypes.string.isRequired,
  linkId: PropTypes.string,
  type: PropTypes.string,
  refetch: PropTypes.func.isRequired,
};

CapResponsesModal.defaultProps = {
  type: 'participants',
  linkId: '',
};

export default CapResponsesModal;
